import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../internal';

// eslint-disable-next-line react/display-name
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#IconSpa16a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.449c-.277-1.583-2.633-3.925-2.956-4.226A9.692 9.692 0 0 1 8 .482a9.691 9.691 0 0 1 2.955 5.742c-.322.3-2.678 2.644-2.955 4.225Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94 15.7a8.545 8.545 0 0 1-5.854-3.113A8.43 8.43 0 0 1 .25 6.139a8.56 8.56 0 0 1 5.968 3.123A8.432 8.432 0 0 1 8 13.15a8.432 8.432 0 0 1 1.783-3.888 8.563 8.563 0 0 1 5.968-3.123 8.447 8.447 0 0 1-1.84 6.448A8.552 8.552 0 0 1 8.057 15.7a.283.283 0 0 0-.041.003H8.01c-.005.002-.008.002-.012.002-.005-.002-.009-.002-.012-.002a.357.357 0 0 1-.042-.003H7.94Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "IconSpa16a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconSpa16 = createIcon(IconComponent);